<template>
<div id="page-notificaciones" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="notifications" title="Notificaciones Enviadas" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="botonAgregar" fab dark x-small color="secondary" slot="activator" @click.native="openModal()" title="Nueva Notificación" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>

                    
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="notificaciones" >Notificaciones Enviadas</v-tab>
                        <v-tab key="notificacionesRFC" >Notificaciones Enviadas RFC</v-tab>
                        
                        <v-tab-item key="notificaciones" >
                            <v-card-text>
                                <v-form ref="form1" >
                                    <v-row wrap>
                                        <v-col lg="5" md="5" sm="12" >
                                            <v-menu offset-x ref="menu0" v-model="menu0" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }" >
                                                    <v-text-field v-on="on" v-model="busqueda.fecha_de" label="Fecha Inicial" clearable
                                                    color="secondary" prepend-icon="event" @blur="busqueda.fecha_de = parseDate(busqueda.fecha_de)" v-mask="'####-##-##'" 
                                                    :rules="[rules.required, validaAnio, validaFechaRango]" ></v-text-field>
                                                </template>

                                                <v-date-picker v-model="busqueda.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu0 = false" >
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menu0 = false" >
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col lg="5" md="5" sm="12" >
                                            <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }" >
                                                    <v-text-field v-on="on" v-model="busqueda.fecha_a" label="Fecha Final" clearable 
                                                    color="secondary" prepend-icon="event" @blur="busqueda.fecha_a = parseDate(busqueda.fecha_a)" v-mask="'####-##-##'" 
                                                    :rules="[rules.required, validaAnio, validaFechaRango]" ></v-text-field>
                                                </template>

                                                <v-date-picker v-model="busqueda.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menu1 = false" >
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col lg="2" md="2" sm="12" >
                                            <v-btn color="blue" @click.native="getNotificaciones()" >
                                                <v-icon>search</v-icon>Buscar
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-client-table ref="vuetable" :data="notificaciones.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>
                                    <template slot="mostrar_aviso" slot-scope="props" >
                                        {{ props.row.mostrar_aviso == 1 ? "Si":"No" }}
                                    <span v-show="props.row.mostrar_aviso == 1" > {{ props.row.activo == true ? " (Activo)":" (Inactivo)" }}</span>
                                    </template>

                                    <template slot="mensaje" slot-scope="props" >
                                        <div class="mensaje" >
                                            {{ getDataMesagge(props.row.mensaje, true) }}

                                            <a @click="props.row.tipo=='IMAGEN'?downloadImagen(getDataMesagge(props.row.mensaje, false), props.row.tipo):
                                            downloadFile(getDataMesagge(props.row.mensaje, false))
                            " class="primary--text" title="Descargar" v-tippy v-if="isDownload(props.row.mensaje)" >
                                                <i class="fa fa-download" style="margin-left: 10px" ></i>
                                            </a>
                                        </div>
                                    </template>

                                    <template slot="fecha" slot-scope="props" >
                                        <span>{{ formatFecha(props.row.fecha) }}</span>                                        
                                    </template>

                                    <template slot="usuario" slot-scope="props" >
                                        <span>{{ getUsuarioRecibe(props.row.usuario) }}</span>
                                    </template>

                                    <template slot="recibe" slot-scope="props" >
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }" >
                                                <span style="color:blue;" v-on="on" >{{ props.row.usuarios.length }} Usuarios</span>
                                            </template>
                                            <span style="font-size:11px;">{{ props.row.usuarios.join(", ") }}</span>
                                        </v-tooltip>
                                        <span></span>
                                    </template>

                                    <template slot="fecha_programado" slot-scope="props" >
                                        <span>{{ formatFecha(props.row.fecha_programado) }}</span>                                        
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-switch v-show="props.row.mostrar_aviso == 1" 
                                            :title="props.row.activo?'Desactivar':'Activar'" v-tippy 
                                            v-model="props.row.activo" color="success" 
                                            @change="props.row.activo?markUnread(props.row.id_notificacion,props.row.recibe):markRead(props.row.id_notificacion,props.row.recibe)" >
                                        </v-switch>                                    
                                    </template>
                                    <template slot="eliminar" slot-scope="props" >
                                        <v-btn fab x-small color="red" @click.native="delete_notificacion(props.row.id_notificacion)" v-tippy title="Eliminar">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item key="notificacionesRFC" >
                            <v-card-text>
                                <v-form ref="busqueda" >
                                    <v-row wrap>
                                        <v-col lg="4" md="4" sm="12">
                                            <v-autocomplete v-model="busqueda.rfc" :items="clientes" :hide-no-data="true" clearable
                                                :hide-selected="true" item-text="identificador" item-value="identificador" 
                                                label="Selecciona un RFC">
                                            </v-autocomplete>
                                        </v-col> 
                                        <v-col lg="3" md="3" sm="12" >
                                            <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }" >
                                                    <v-text-field v-on="on" v-model="busqueda.fecha_de" label="Fecha Inicial" clearable
                                                    color="secondary" prepend-icon="event" @blur="busqueda.fecha_de = parseDate(busqueda.fecha_de)" v-mask="'####-##-##'" 
                                                    :rules="[rules.required, validaAnio, validaFechaRango]" ></v-text-field>
                                                </template>

                                                <v-date-picker v-model="busqueda.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menu2 = false" >
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col lg="3" md="3" sm="12" >
                                            <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }" >
                                                    <v-text-field v-on="on" v-model="busqueda.fecha_a" label="Fecha Final" clearable 
                                                    color="secondary" prepend-icon="event" @blur="busqueda.fecha_a = parseDate(busqueda.fecha_a)" v-mask="'####-##-##'" 
                                                    :rules="[rules.required, validaAnio, validaFechaRango]" ></v-text-field>
                                                </template>

                                                <v-date-picker v-model="busqueda.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menu3 = false" >
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col lg="2" md="2" sm="12" >
                                            <v-btn color="blue" @click.native="getNotificacionesRFC()" >
                                                <v-icon>search</v-icon>Buscar
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-client-table ref="vuetablerfc" :data="notificacionesRFC.items" :columns="columnsRFC" :options="optionsRFC" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>
                                    <template slot="mostrar_aviso" slot-scope="props" >
                                        {{ props.row.mostrar_aviso == 1 ? "Si":"No" }}
                                    <span v-show="props.row.mostrar_aviso == 1" > {{ props.row.activo == true ? " (Activo)":" (Inactivo)" }}</span>
                                    </template>

                                    <template slot="mensaje" slot-scope="props" >
                                        <div class="mensaje" >
                                            {{ getDataMesagge(props.row.mensaje, true) }}
                                            <a @click="props.row.tipo=='IMAGEN'?downloadImagen(getDataMesagge(props.row.mensaje, false), props.row.tipo):
                                            downloadFile(getDataMesagge(props.row.mensaje, false))
                            " class="primary--text" title="Descargar" v-tippy v-if="isDownload(props.row.mensaje)" >
                                                <i class="fa fa-download" style="margin-left: 10px" ></i>
                                            </a>
                                        </div>
                                    </template>

                                    <template slot="usuario" slot-scope="props" >
                                        <span>{{ getUsuarioRecibe(props.row.usuario) }}</span>
                                    </template>

                                    <template slot="fecha" slot-scope="props" >
                                        <span>{{ formatFecha(props.row.fecha) }}</span>
                                    </template>

                                    <template slot="fecha_programado" slot-scope="props" >
                                        <span>{{ formatFecha(props.row.fecha_programado) }}</span>                                        
                                    </template>

                                    <template slot="actions" slot-scope="props" >                    
                                        <v-switch v-show="props.row.mostrar_aviso == 1" 
                                            :title="props.row.activo?'Desactivar':'Activar'" v-tippy 
                                            v-model="props.row.activo" color="success" 
                                            @change="props.row.activo?markUnreadRFC(props.row.id_notificacion):markReadRFC(props.row.id_notificacion)" >
                                        </v-switch>                                    
                                    </template>
                                    <template slot="eliminar" slot-scope="props" >
                                        <v-btn fab x-small color="red" @click.native="delete_notificacion_rfc(props.row.id_notificacion)" v-tippy title="Eliminar">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>
                    </v-tabs>

                        <v-dialog v-model="modal" max-width="50%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>
                                        <span class="subheading" >
                                            <strong>Nueva Notificación</strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="tipo" label="Tipo" type="text" v-model="model.tipo" :rules="[rules.required]" maxlength="50" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="titulo" label="Título" type="text" v-model="model.titulo" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="mensaje" label="Mensaje" type="text" v-model="model.mensaje" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-switch v-model="model.mostrar_aviso" class="ma-2" label="Seleccionar si desea mostrar aviso al usuario cuando inicie sesión" ></v-switch>
                                                </v-flex>                                                
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_programado" label="Ingrese fecha si desea programar la notificación" color="secondary" prepend-icon="event" @blur="model.fecha_programado = parseDate(model.fecha_programado)" v-mask="'####-##-##'" :rules="[validaFecha]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="model.fecha_programado" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu4 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>                                                
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12 v-if="!todos" >
                                                    <v-autocomplete v-model="model.usuarios" :items="usuarios" :hide-no-data="true" multiple chips deletable-chips :hide-selected="true" :return-object="false" ref="selectUsuario" :item-text="concatenaUsuario" item-value="id_usuario" label="Selecciona un Usuario" :rules="[rules.required]" ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-switch v-model="todos" class="ma-2" label="Seleccionar todos los RFCs" ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12 v-if="!todos" >
                                                    <v-autocomplete v-model="model.clientes" :items="clientes" :hide-no-data="true" multiple chips deletable-chips :hide-selected="true" :return-object="false" ref="selectCliente" :item-text="concatenaCliente" item-value="id_cliente" label="Selecciona un Rfc" ></v-autocomplete>
                                                </v-flex>                                                
                                            </v-layout>                                            
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>Enviar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";

export default {
    created: function () {  
        this.getClientes();      
        this.getUsuarios();        
        /*(this.$options.sockets.onmessage = data => {
            var data = JSON.parse(data.data);
            let notificacion = data["notificacion"];

            //if (notificacion != undefined)
                //if (notificacion.usuario == this.$local_storage.get("id_usuario"))
                    //this.getNotificaciones();
        }),*/
        (this.botonAgregar =
            this.$local_storage.get("tipo_usuario") == "Super Usuario" ||
            this.$local_storage.get("tipo_usuario") == "Soporte");

        if (this.$local_storage.get("redirectFromNotificaciones") == 1) {
            this.openModal();
            this.$local_storage.set("redirectFromNotificaciones", 0);
        };

    },
    data() {
        return {
            menu0: false,
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            fab: false,
            todos: false,
            file: '',
            fileName: '',
            name: "datagrid",
            modal: false,
            loading: false,
            botonAgregar: false,
            columns: ["usuario","titulo", "mensaje","tipo", "fecha", 'recibe', 'fecha_programado', 'mostrar_aviso', 'actions','eliminar'],
            show_loading: true,
            options: {
                filterable: ["titulo", "mensaje", "tipo", "fecha", 'fecha_programado', 'mostrar_aviso'],
                sortable: ["usuario", "titulo", "mensaje", "tipo", "fecha", 'recibe', 'fecha_programado', 'mostrar_aviso'],
                headings: {        
                    titulo:"Título",
                    usuario:"Envió",            
                    recibe: "Recibió",
                    actions: "Activar/Desactivar Aviso"
                },
                 listColumns: {
                    mostrar_aviso: [{
                            id: 1,
                            text: "Si"
                        },
                        {
                            id: 0,
                            text: "No"
                        },
                        {
                            id: null,
                            text: "Todos"
                        }
                    ]
                }
            },
            columnsRFC: ["usuario","titulo","mensaje", "tipo", "fecha", 'rfc', "fecha_programado","actions","eliminar"],
            optionsRFC: {
                filterable: ["titulo","mensaje", "tipo", "fecha", 'rfc', "fecha_programado"],
                sortable: ["usuario","titulo","mensaje", "tipo", "fecha", 'rfc', "fecha_programado"],
                headings: {
                    usuario:"Envió",
                    actions: "Activar/Desactivar Aviso",
                    rfc: "RFC"
                },               
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Notificaciones",
                    disabled: true,
                    href: ""
                }
            ],
            model: {
                tipo: "",
                mensaje: "",
                titulo: "",
                usuarios: [],
                clientes: [],
                fecha_programado: "",
            },
            usuarios: [],
            usuariosAll: [],
            clientes: [],
            rules: {
                required: v => !!v || "Este campo es requerido"
            },
            notificaciones: {
                selected: [],
                headers: [{
                        text: "Notificación",
                        value: "nombre"
                    },
                    {
                        text: "Operaciones",
                        value: "operaciones",
                        align: "center"
                    }
                ],
                items: []
            },
            notificacionesRFC: {
                items: []
            },
            
            busqueda:{
                rfc:"",
                fecha_de:"",
                fecha_a:"",
                usuario:"",
            },
        };
    },
    methods: {      
         markRead: function (id_notificacion, id_usuario) {                                   
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .put(this.$hostname + "notificaciones/mark_as_read_agrupado/", {                     
                    usuario: id_usuario,
                    id_notificacion: id_notificacion
                })
                .then(response => {                    
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al desactivar el aviso.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                }).then(()=>{                   
                    this.getNotificaciones();
                });
        },
         markUnread: function (id_notificacion, id_usuario) {                                    
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .put(this.$hostname + "notificaciones/mark_as_unread_agrupado/", {                                    
                    usuario: id_usuario,
                    id_notificacion: id_notificacion
                })
                .then(response => {                    
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al activar el aviso.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                }).then(()=>{                    
                    this.getNotificaciones();
                });
        },  
        delete_notificacion: function (id_notificacion) {   
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Desea eliminar la notificación?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .post(this.$hostname + "notificaciones/delete_notificacion/", {
                            id_notificacion: id_notificacion
                        })
                        .then(response => {
                        })
                        .catch(error => {
                            console.log(error);
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el aviso.",
                                footer: ""
                            });
                            this.$root.$dialogLoader.hide();
                        }).then(()=>{                    
                            this.getNotificaciones();
                        });                    
                }
            });

        },  
        delete_notificacion_rfc: function (id_notificacion) {   
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Desea eliminar la notificación?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .post(this.$hostname + "notificaciones/delete_notificacion_rfc/", {                        
                            id_notificacion: id_notificacion
                        })
                        .then(response => {
                        })
                        .catch(error => {
                            console.log(error);
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el aviso.",
                                footer: ""
                            });
                            this.$root.$dialogLoader.hide();
                        }).then(()=>{     
                            this.getNotificacionesRFC();               
                            this.getNotificaciones();
                        });                    
                }
            });

        },  
        markReadRFC: function (id_notificacion) {                                   
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .put(this.$hostname + "notificaciones/mark_as_read_rfc/", {                                 
                    id_notificacion: id_notificacion
                })
                .then(response => {                    
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al desactivar el aviso.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                }).then(()=>{                    
                    this.getNotificacionesRFC();
                    this.getNotificaciones();
                });
        },
         markUnreadRFC: function (id_notificacion) {                                    
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .put(this.$hostname + "notificaciones/mark_as_unread_rfc/", {                                    
                    id_notificacion: id_notificacion
                })
                .then(response => {                           
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al activar el aviso.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                }).then(()=>{                    
                    this.getNotificacionesRFC();
                    this.getNotificaciones();
                });
        },  
        validaBusqueda: function(){
            if((this.busqueda.rfc!=undefined && this.busqueda.rfc!="") || (
                this.busqueda.fecha_de!=undefined && this.busqueda.fecha_de!=""
                && this.busqueda.fecha_a!=undefined && this.busqueda.fecha_a!=""))
                return true;
            else{
                return "Debe seleccionar RFC y/o rango de fechas";
            }
        },
        validaFechaRango: function(fecha){
             if (fecha == "Invalid date")
                return "Fecha no válida.";
            else 
              return true;
        },
        validaAnio: function(){
            if (this.busqueda.fecha_de != "" && this.busqueda.fecha_a != ""){
                var inicio = moment(this.busqueda.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.busqueda.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (diferencia > 366)
                    return "Periodo máximo 1 año."
            }
            return true;
        },
        validaFecha: function(fecha){        
            if (fecha == "Invalid date") {
                return "Fecha no válida."
            } else if (this.model.fecha_programado != undefined && this.model.fecha_programado != ""){
                var inicio = moment(new Date()).format("YYYY-MM-DD");
                var fin = moment(this.model.fecha_programado, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                
                if (diferencia < 0)
                    return "La Fecha Programada no debe ser menor a la fecha actual."                
            }
            return true;
        },  

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            var nombre = this.file.name.split(".");

            if (this.file.size > 1000 * 1000 * 3) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no debe ser mayor a 3MB.",
                });
                this.file = "";
                this.fileName = "";
            } else {
                this.fileName = this.file.name;
                const fr = new FileReader();
                fr.readAsDataURL(this.$refs.file.files[0]);
                fr.addEventListener('load', () => {
                    this.file = fr.result; // archivo en base64
                });                
            }
        },
        isDownload: function (message) {
            try {
                let mess = JSON.parse(message);

                return true;
            } catch (e) {
                return false;
            }
        },
        getDataMesagge: function (message, flag_id) {
            try {
                let mess = JSON.parse(message);

                if (!flag_id) return mess.file;
                else return mess.texto;
            } catch (e) {
                return message;
            }
        },
        downloadImagen: function (id, tipo) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           console.log('img');

            var datos = {
                id: id,
                bucket: "descargas.econnectpro.mx"
            }

            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                     
                        var image = new Image();
                        image.src = res.data.mensaje;

                        var w = window.open("");
                        w.document.write(image.outerHTML);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }

            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadReport: function (id, tipo) {
            let name = id.split("/");
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            console.log('file');
            console.log('.' + tipo + '.')
           let data= {
                        id: id
                    };
            if(tipo !='Alerta')
            data= {
                    id: id,
                    bucket: "descargas.econnectpro.mx"
             };
            
            axios
                .post(
                    this.$hostname + "s3/download/",data, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Allow: "POST",
                        "cache-control": "no-cache",
                        responseType: "arraybuffer"
                    }
                )
                .then(response => {
                    
                  
                        let blob = new Blob([response.data], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        a.download = name[name.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);
                    
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!" + tipo,
                        text: "Ocurrió un error al descargar el reporte.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        openModal: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.todos = "",
            this.model.usuarios = []; 
                       
            this.modal = true;
            this.reset();
        },

        formatFecha: function (fecha) {
            if(fecha != null && fecha!=""){
                var date = fecha.substr(0, 10);
                date = date.split("-");

                return date[2] + "/" + date[1] + "/" + date[0];
            } else 
                return "";
            
        },
        getNotificaciones: function () {
            if (this.$refs.form1.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let id_usuario = parseInt(this.$local_storage.get("id_usuario"));

                axios
                    .post(this.$hostname + "notificaciones/list_notificaciones/", {                    
                        usuario: 0,
                        fecha_de: this.busqueda.fecha_de,
                        fecha_a: this.busqueda.fecha_a
                    })
                    .then(response => {
                        this.notificaciones.items = [];
                        if(response.data.length > 0){
                            var agrupado = [];
                            var grupos = {};
                            
                            response.data.forEach( n => {
                                if(grupos[n.id_notificacion] != null){
                                    grupos[n.id_notificacion].usuarios.push(this.getUsuarioRecibe(n.recibe));
                                } else {
                                    grupos[n.id_notificacion] = n;
                                    grupos[n.id_notificacion].usuarios = [];
                                    grupos[n.id_notificacion].usuarios.push(this.getUsuarioRecibe(n.recibe));
                                }
                                if(n.estatus ==0) //Si hay una No Leida, se queda no leída
                                    grupos[n.id_notificacion].estatus = 0;
                            });

                            for(var k in grupos){
                                this.notificaciones.items.push(grupos[k]);
                            }

                            //this.notificaciones.items = response.data;
                            this.notificaciones.items.sort(function(a, b) {
                                //Ordenar por fecha más reciente
                                return new Date(b.fecha) - new Date(a.fecha);
                            });
                            for(var k in this.notificaciones.items){
                                this.notificaciones.items[k].activo = this.notificaciones.items[k].estatus==0?true:false;                        
                            }
                            var filter = this.notificaciones.items.filter(function (item) {
                                return item.estatus == 0;
                            });
                            this.$root.$emit("notificationsUpdate", filter.length);
                        }
                        
                    })
                    .catch(error => {
                        console.log(error);
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener las notificaciones.",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        getNotificacionesRFC: function () {  
            
            if (this.$refs.busqueda.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let id_usuario = parseInt(this.$local_storage.get("id_usuario"));
                var datos = this.busqueda;
                datos['usuario'] = id_usuario;
                if (datos.fecha_de == undefined || datos.fecha_de == null )
                    datos.fecha_de = "";
                if (datos.fecha_a == undefined || datos.fecha_a == null )
                    datos.fecha_a = "";
                if (datos.rfc == undefined || datos.rfc == null )
                    datos.rfc = "";

                axios
                    .post(this.$hostname + "notificaciones/list_notificaciones_rfc/", datos)                                      
                    .then(response => {                    
                        this.notificacionesRFC.items = response.data;
                        this.notificacionesRFC.items.sort(function(a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha);
                        });
                        for(var k in this.notificacionesRFC.items){
                            this.notificacionesRFC.items[k].activo = this.notificacionesRFC.items[k].estatus==0?true:false;
                        }
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener las notificaciones por RFC.",
                            footer: ""
                        });
                    }).then(()=>{
                        this.$root.$dialogLoader.hide();
                    });
            }            
        },
        guardar() {
            
            var datos = Vue.util.extend({}, this.model);

            datos.envia = this.$local_storage.get("id_usuario");

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else if ((this.model.usuarios.length + this.model.clientes.length)<= 0 && this.todos == false) {
                this.$swal({
                    position: "center",
                    type: "warning",
                    title: "Cuidado!",
                    text: "Debe seleccionar al menos un Usuario o un RFC"
                });
                this.$nextTick(() => this.$refs.selectUsuario.focus());
                return false;
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                if (datos.mostrar_aviso == undefined || datos.mostrar_aviso == "" || datos.mostrar_aviso == null)
                    delete(datos['mostrar_aviso'])

                if (datos.fecha_programado == undefined || datos.fecha_programado == "" || datos.fecha_programado == null)
                    delete(datos['fecha_programado'])

                if (this.todos) {
                    //Solicitaron que se quitara el de todos los usuarios, y se cambiara por todos los RFCs
                    datos.usuarios = [];
                    datos.clientes = ["todos"];

                    //for (var i = 0; i < this.clientes.length; i++)
                    //    datos.clientes.push(this.clientes[i].id_cliente);
                }

                console.log(datos);
                //this.$root.$dialogLoader.hide();
                //return false;

                if (this.file != '') {
                    var keyBucket = "notificaciones/" + Math.random() + '_' + this.fileName;

                    /*let formData = new FormData();
                    formData.append('file', this.file);
                    formData.append('key', keyBucket);*/
                    let formData = {
                        file: this.file,
                        key: keyBucket,
                        bucket_alt: "descargas.econnectpro.mx"
                    };

                    datos.mensaje = JSON.stringify({
                        "texto": datos.mensaje,
                        "file": keyBucket
                    });

                    axios.post(this.$hostname + 's3/upload/', formData)
                        .then((res) => {
                            if (typeof res.data !== 'undefined') {

                                axios
                                    .post(this.$hostname + "notificaciones/create_notificacion/", datos)                                    
                                    .then(res => {
                                        this.$swal({
                                            type: "success",
                                            title: "¡Operación Exitosa!",
                                            text: "Los datos se guardaron correctamente",
                                            footer: ""
                                        });
                                    })
                                    .catch(error => {
                                        this.$swal({
                                            type: "success",
                                            title: "¡Operación Exitosa!",
                                            text: "Los notificación se esta procesando, consulte mas tarde",
                                            footer: ""
                                        });
                                        console.log(error);
                                    })
                                    .then(() => {                                        
                                        this.$root.$dialogLoader.hide();                                        
                                        this.modal = false;
                                    });
                            }
                        })
                        .catch((error) => {
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                            type: "success",
                                            title: "¡Operación Exitosa!",
                                            text: "Los notificación se esta procesando, consulte mas tarde",
                                            footer: ""
                                        });
                            console.log(error);
                        });
                } else

                    axios
                    .post(this.$hostname + "notificaciones/create_notificacion/", datos)                                    
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                                            type: "success",
                                            title: "¡Operación Exitosa!",
                                            text: "Los notificación se esta procesando, consulte mas tarde",
                                            footer: ""
                                        });
                        console.log(error);
                    })
                    .then(() => {                        
                        this.$root.$dialogLoader.hide();                                               
                        this.modal = false;
                    });
                
            }
        },
        getUsuarios: function () {            
            let id_usuario = this.$local_storage.get("id_usuario");
            axios
                .get(this.$hostname + "usuarios/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.usuariosAll = res.data;
                        
                        this.usuarios = res.data;
                        /*var filter = res.data.filter(function (item) {
                            return item.estatus == true && item.id_usuario != id_usuario && item.id_usuario>0 ;
                        });
                        this.usuarios = filter;*/
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        reset() {
            const input = this.$refs.file;
            if(input != undefined){
                input.type = 'text';
                input.type = 'file';
                this.file = "";
                this.fileName = "";            
            }            
        },
        getClientes: function () {
            axios.get(this.$hostname + "clientes/")
                .then(response => {
                    var clientesActivos = response.data.filter(cliente => {
                        return cliente.estatus == 1;
                    });

                    this.clientes = clientesActivos.sort(function(a, b) {
                        if (a.identificador < b.identificador) {
                            return -1;
                        }
                        if (a.identificador > b.identificador) {
                            return 1;
                        }
                        // a debe ser igual b
                        return 0;
                    });

                })
                .catch(error => {                    
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                });
        },
        concatenaUsuario: item =>
            item.nombre + " " + item.apellidos + " (" + item.username + ")",
        concatenaCliente: item =>
            item.identificador + " (" + item.nombre + ")",

        getUsuarioRecibe: function (id_usuario) {
            let usuario = this.usuariosAll.filter((usuario) => usuario.id_usuario == id_usuario)[0];
            return usuario != undefined ? usuario.username : '';
        }
    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
.elevation-2 >>> .mensaje{
    white-space: normal !important;
    max-width: 300px !important;
    min-width: 300px !important;
    text-align: justify !important;
}
</style>
